<template>
  <div class="col-sm-12 nopads">
    <div v-if="workAssignment">
      <div class="row">
        <div class="col-12 d-flex justify-content-between align-items-center pb-1">
            <div class="flex-grow-1">
                <h4 class="form-header pointer hover-header" @click.stop="detailsVisible = !detailsVisible">{{ $t('work_assignment.title') }}</h4>
            </div>
            <div class="ms-2 px-2" @click.stop="detailsVisible = !detailsVisible">
                <font-awesome-icon icon="arrow-down" class="pointer no-focus arrow-icon dont-print hover-header" :class="{ rotated: detailsVisible }"/>
            </div>
        </div>
        <div class="routa-collapse" :class="{ collapsed: detailsVisible }">
            <div class="row">
              <div class="col-sm-6 nopads">
                <span class="item-detail-title">{{ $t('observations.created_time') }}</span>
                <span class="item-detail-text">{{ toLocalTime(workAssignment.created) }}</span>
              </div>
              <div class="col-sm-6 nopads">
                <span class="item-detail-title">{{ $t('orders.status') }}</span>
                <span class="item-detail-text">{{ getStatusString(workAssignment.status) }}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6 nopads">
                <span class="item-detail-title">{{ $t('work_assignment.created_by') }}</span>
                <span class="item-detail-text">{{
                  workAssignment.created_by.last_name
                }}, {{ workAssignment.created_by.first_name }}</span>
              </div>
              <div class="col-sm-6 nopads">
                <span class="item-detail-title">{{ $t('work_assignment.assigned_to') }}</span>
                <span
                  v-if="workAssignment.assigned_to"
                  class="item-detail-text"
                >{{
                  workAssignment.assigned_to.last_name
                }}, {{ workAssignment.assigned_to.first_name }}</span>
                <span
                  v-else
                  class="item-detail-text"
                >-</span>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6 nopads">
                <span class="item-detail-title">{{ $t('orders.info') }}</span>
                <span class="item-detail-text">{{ workAssignment.info || ' - ' }}</span>
              </div>
              <div
                v-if="workAssignment.closing_date"
                class="col-sm-6 nopads"
              >
                <span class="item-detail-title">{{ $t('observations.closed_time') }}</span>
                <span class="item-detail-text">{{ toLocalTime(workAssignment.closing_date) }}</span>
              </div>
            </div>
      </div>
    </div>
        <div
          v-if="!loading && !workAssignment && !canAdd"
          class="pt-2"
        >
          {{ $t('work_assignment.assignment') }}
        </div>
    </div>
    <div
      v-if="canAdd || (canEdit && workAssignment)"
      class="button-container"
    >
      <button
        :disabled="loading"
        class="btn btn-sm btn-primary form-button"
        @click.stop="$emit('editAssignment', workAssignment)"
      >
        {{ workAssignment ? $t('work_assignment.edit') : $t('work_assignment.add') }}
      </button>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {workAssignmentHelper} from '../mixins/WorkAssignmentMixin'
import {timeUtils} from '../mixins/TimeUtils'

export default {
    name: 'WorkAssignmentView',
    mixins: [restApi, workAssignmentHelper, timeUtils],
    props: ['id', 'type', 'canAdd', 'canEdit'],
    data: function () {
        return {
            workAssignment: null,
            loading: true,
            detailsVisible: false
        }
    },
    mounted: function () {
        this.fetchAssignment()
    },
    methods: {
        fetchAssignment: function () {
            this.loading = true
            this.restFetchParams(this.workAssignmentByDefectUrl, {
                type: this.type,
                id: this.id
            }, this.success, this.fail)
        },
        success: function (response) {
            this.loading = false
            this.workAssignment = response.data
        },
        fail: function () {
            this.loading = false
            this.workAssignment = null
        }
    }

}
</script>
